module.exports = __webpack_public_path__ + "static/media/green-logo.b189e385.svg";